// New visits default to the waiting room; future days are decided on the site's calendar.

import { getCurrentTimeInTimezone } from 'common/services/dateService'
import type { IPatientRoom } from 'features/Home/interfaces/IInfoPatient'

// A YYYY-MM-DD day after today in the site's zone; no zone means we cannot tell.
export const isFutureSiteDay = (day: string | undefined, timeZone: string | undefined): boolean => {
  if (!day || !timeZone) return false
  return day > getCurrentTimeInTimezone(timeZone).format('YYYY-MM-DD')
}

// Every new appointment starts in the waiting room; a site without one keeps the fallback.
export const defaultCreateRoom = (rooms: IPatientRoom[], fallback = ''): string => {
  const waitingRoom = rooms.find((item) => item.is_waiting_room)
  return waitingRoom ? String(waitingRoom.value) : fallback
}

export const roomForDay = (
  room: string,
  day: string | undefined,
  timeZone: string | undefined,
  rooms: IPatientRoom[],
): string => {
  return isFutureSiteDay(day, timeZone) ? defaultCreateRoom(rooms, room) : room
}
